// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TwWL","type":"styles_type__18FMF","choices":"styles_choices__K5G8l"};